import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

import { Button } from '@/components/ui/button';
import { PageActions, PageBreadcrumb, PageBreadcrumbSegment, PageHeader } from 'components/PageHeader';
import {
    QuantityGenerationPopup,
    type QuantityGenerationColumn,
} from 'pages/MicrostoreColumnGroups/Popups/QuantityGenerationPopup';
import { StockTransferGenerationPopup } from 'pages/MicrostoreColumnGroups/Popups/StockTransferGenerationPopup';
import { ColumnsList } from './components/ColumnsList';

export const MicrostoreColumns = () => {
    const [selectedColumns, setSelectedColumns] = useState<QuantityGenerationColumn[]>([]);
    const [isQuantityGenerationPopupOpen, setIsQuantityGenerationPopupOpen] = useState(false);
    const [isStockTransferGenerationPopupOpen, setIsStockTransferGenerationPopupOpen] = useState(false);

    return (
        <Container>
            <Helmet title="Colonnes microstore · TOTADMIN" />
            <PageHeader>
                <PageBreadcrumb>
                    <PageBreadcrumbSegment label="Colonnes microstore" isCurrent />
                </PageBreadcrumb>
                <PageActions>
                    <Button size="sm" variant="outline" onClick={() => setIsQuantityGenerationPopupOpen(true)}>
                        Générer Qté{selectedColumns.length ? ` (${selectedColumns.length})` : ''}
                    </Button>
                    <Button size="sm" variant="outline" onClick={() => setIsStockTransferGenerationPopupOpen(true)}>
                        Transferts de stock{selectedColumns.length ? ` (${selectedColumns.length})` : ''}
                    </Button>
                </PageActions>
            </PageHeader>
            <Content>
                <ListContainer>
                    <ColumnsList onSelectedColumnsChange={setSelectedColumns} />
                </ListContainer>
            </Content>
            {isQuantityGenerationPopupOpen ? (
                <QuantityGenerationPopup
                    isOpen={isQuantityGenerationPopupOpen}
                    setIsOpen={setIsQuantityGenerationPopupOpen}
                    initialColumns={selectedColumns}
                />
            ) : null}
            {isStockTransferGenerationPopupOpen ? (
                <StockTransferGenerationPopup
                    isOpen={isStockTransferGenerationPopupOpen}
                    setIsOpen={setIsStockTransferGenerationPopupOpen}
                    initialColumns={selectedColumns}
                />
            ) : null}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
